import { render, staticRenderFns } from "./FileUploadMessageSimple.vue?vue&type=template&id=52308cac&scoped=true&"
import script from "./FileUploadMessageSimple.vue?vue&type=script&lang=js&"
export * from "./FileUploadMessageSimple.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadMessageSimple.vue?vue&type=style&index=0&id=52308cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52308cac",
  null
  
)

export default component.exports